/**
 * @file TransferCancelDialog.tsx
 * @description Подтверждение отмены перемещения (phase19.24 этап 1, шаг 1).
 *
 * Отмена — единственное необратимое действие в «⋯» черновика перемещения, и
 * до фикса она срабатывала с первого тапа: пункт меню на телефоне стоит рядом
 * с «Звуком скана», промахнуться легко (замечание ревью 2026-09-20). Образец —
 * `PickingConfirmDialog` сборки: тот же `AlertDialog`, fullScreen на `<sm`,
 * тач-цели ≥48px.
 *
 * Текст честно говорит, что будет со строками: они остаются в документе
 * только для истории — иначе менеджер боится, что отмена их сотрёт.
 */

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../ui/alert-dialog";
import { Button } from "../../ui/button";

interface Props {
  open: boolean;
  /** Номер документа — в тексте подтверждения (MV-2026-000002). */
  number: string;
  busy: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function TransferCancelDialog({
  open,
  number,
  busy,
  onCancel,
  onConfirm,
}: Props) {
  return (
    <AlertDialog open={open} onOpenChange={(v) => (!v ? onCancel() : null)}>
      <AlertDialogContent fullScreen className="max-w-md gap-3">
        <AlertDialogHeader>
          <AlertDialogTitle>Отменить перемещение?</AlertDialogTitle>
          <AlertDialogDescription>
            Перемещение {number} будет отменено, строки останутся в документе
            только для истории. Продолжить?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="ghost" className="min-h-12" onClick={onCancel} disabled={busy}>
            Не сейчас
          </Button>
          <Button
            variant="destructive"
            className="min-h-12"
            onClick={onConfirm}
            disabled={busy}
          >
            Отменить перемещение
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
